export enum DataDownloadInterval {
  FiveMinutes = "5 mins",
  ThirtyMinutes = "30 mins",
}
